module.exports = __webpack_public_path__ + "static/media/logo-dark-ra.b24e9028.png";